export default (() => {
    console.log('UNTUCKit : Module : Accordion : loaded');
    const SLIDE_DURATION_MS = 400;
    const slideAnimations = new WeakMap();
    const contentSiblings = (toggle) => {
        const parent = toggle.parentElement;
        if (!parent) {
            return [];
        }
        return Array.from(parent.children).filter((element) => element !== toggle &&
            element instanceof HTMLElement &&
            element.classList.contains('js-accordion-content'));
    };
    const clearMotionStyles = (content) => {
        content.style.height = '';
        content.style.overflow = '';
        content.style.paddingTop = '';
        content.style.paddingBottom = '';
        content.style.marginTop = '';
        content.style.marginBottom = '';
    };
    const stopSlide = (content) => {
        const animation = slideAnimations.get(content);
        if (!animation) {
            return;
        }
        try {
            animation.commitStyles();
        }
        catch {
            // The animation may not have applied a style yet.
        }
        animation.cancel();
        slideAnimations.delete(content);
    };
    const slideFrame = (content) => {
        const computed = getComputedStyle(content);
        const paddingTop = parseFloat(computed.paddingTop) || 0;
        const paddingBottom = parseFloat(computed.paddingBottom) || 0;
        const borderTop = parseFloat(computed.borderTopWidth) || 0;
        const borderBottom = parseFloat(computed.borderBottomWidth) || 0;
        const height = computed.boxSizing === 'border-box'
            ? content.offsetHeight
            : content.offsetHeight - paddingTop - paddingBottom - borderTop - borderBottom;
        return {
            height: `${Math.max(height, 0)}px`,
            paddingTop: computed.paddingTop,
            paddingBottom: computed.paddingBottom,
            marginTop: computed.marginTop,
            marginBottom: computed.marginBottom,
        };
    };
    const collapsedFrame = {
        height: '0px',
        paddingTop: '0px',
        paddingBottom: '0px',
        marginTop: '0px',
        marginBottom: '0px',
    };
    const playSlide = (content, frames, display) => {
        const animation = content.animate(frames, {
            duration: SLIDE_DURATION_MS,
            easing: 'ease-in-out',
            fill: 'forwards',
        });
        slideAnimations.set(content, animation);
        animation.onfinish = () => {
            if (slideAnimations.get(content) !== animation) {
                return;
            }
            slideAnimations.delete(content);
            clearMotionStyles(content);
            content.style.display = display;
            animation.cancel();
        };
    };
    const slideDown = (content) => {
        stopSlide(content);
        clearMotionStyles(content);
        content.style.display = 'block';
        content.style.height = 'auto';
        const expanded = slideFrame(content);
        content.style.overflow = 'hidden';
        content.style.height = '0px';
        content.style.paddingTop = '0px';
        content.style.paddingBottom = '0px';
        content.style.marginTop = '0px';
        content.style.marginBottom = '0px';
        playSlide(content, [collapsedFrame, expanded], 'block');
    };
    const slideUp = (content) => {
        stopSlide(content);
        if (getComputedStyle(content).display === 'none') {
            clearMotionStyles(content);
            content.style.display = 'none';
            return;
        }
        const expanded = slideFrame(content);
        content.style.overflow = 'hidden';
        content.style.height = expanded.height;
        content.style.paddingTop = expanded.paddingTop;
        content.style.paddingBottom = expanded.paddingBottom;
        content.style.marginTop = expanded.marginTop;
        content.style.marginBottom = expanded.marginBottom;
        playSlide(content, [expanded, collapsedFrame], 'none');
    };
    const onToggleClick = (event) => {
        if (!(event.currentTarget instanceof HTMLElement)) {
            return;
        }
        const toggle = event.currentTarget;
        const contents = contentSiblings(toggle);
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        contents.forEach((content) => {
            const hidden = getComputedStyle(content).display === 'none';
            if (reduceMotion) {
                stopSlide(content);
                clearMotionStyles(content);
                content.style.display = hidden ? 'block' : 'none';
                return;
            }
            if (hidden) {
                slideDown(content);
            }
            else {
                slideUp(content);
            }
        });
        toggle.classList.toggle('active');
    };
    const init = () => {
        console.log('UNTUCKit : Module : Accordion : init');
        document.querySelectorAll('.js-accordion-toggle').forEach((toggle) => {
            toggle.addEventListener('click', onToggleClick);
        });
    };
    return { init };
})();
